import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'

import { Box, Grid, Stack, SxProps, Typography } from '@mui/material'
import { Loading } from 'components/ui'
import { Paper } from 'oneui'
import { IconStyle, SummaryPaperLargeStyle, SummaryPaperSmallStyle, SummaryPaperStyle } from 'styles/theme/theme'
import { EVENT_KEYS } from 'utils/constants'

import { AutomationTagIds } from '../../assets/test/test-automation-tag-id'

type Props = {
  size?: 'small' | 'large'
  pageUrl: string
  isLoading: boolean
  titleIcon: string
  title: string
  content: ReactNode
  paperSx?: SxProps
}
const Summary = ({ size = 'large', pageUrl, isLoading, titleIcon, title, content, paperSx }: Props) => {
  const navigate = useNavigate()

  const handleNavigatePage = () => {
    navigate(pageUrl)
  }

  return (
    <Box
      tabIndex={0}
      onClick={handleNavigatePage}
      onKeyDown={(event) => {
        if (event.key === EVENT_KEYS.SPACE || event.key === EVENT_KEYS.ENTER) {
          event.preventDefault()
          handleNavigatePage()
        }
      }}
      style={{ cursor: 'pointer' }}
      data-testid='Box7EC87D17'
    >
      <Paper
        sx={{
          ...SummaryPaperStyle,
          ...(size === 'large' ? SummaryPaperLargeStyle : SummaryPaperSmallStyle),
          ...paperSx
        }}
      >
        {isLoading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
            <Loading />
          </Box>
        ) : (
          <Stack justifyContent='flex-start' alignItems='center' sx={{ height: '100%' }}>
            <Grid
              container
              alignItems='center'
              wrap='nowrap'
              sx={{ marginBottom: { xs: '16px', md: '48px' }, ...(size === 'small' && { marginBottom: '16px' }) }}
            >
              <Box component='img' src={titleIcon} sx={{ ...IconStyle }} alt='' />
              <Box sx={{ mx: { xs: '16px', md: '18px' } }}>
                <Typography
                  fontSize={{ xs: '17px', md: '18px' }}
                  fontWeight='bold'
                  sx={{ textTransform: 'uppercase', overflowWrap: 'anywhere' }}
                  data-testid={AutomationTagIds['cards.dashboard-title'] + title}
                >
                  {title}
                </Typography>
              </Box>
            </Grid>
            {content}
          </Stack>
        )}
      </Paper>
    </Box>
  )
}

export default Summary
